export const TERTIARY = {
  DEFAULT: '#29e000',
  LIGHT: '#acff99',
  LIGHTER: '#ceffc2',
  LIGHTEST: '#e1ffda',
} as const;
